var scope_0 = require('/Users/renebroich/neudevelop/laptopladen_Kopie/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/Users/renebroich/neudevelop/laptopladen_Kopie/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    